import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Card, CircularProgress, Grid } from '@material-ui/core';

import HoSoDetail from '../../../containers/GTNS/HoSo/HoSoDetail';
import DanhSachThanhTichProfile from '../../../containers/QCV/DanhSachThanhTich/DanhSachThanhTichProfile';

// Màn "Duyệt thành tích" (giống Quả Cầu Vàng): profile ứng viên (trái) +
// bảng thành tích KHCN có nút "Xác nhận" để chấm điểm từng thành tích (phải).
export default function DuyetThanhTich() {
  const role = useSelector((state) => state.userReducer.user?.role);
  const loading = useSelector((state) => state.formReducer.loading);
  const isSuperAdmin =
    role === 'super_admin' ||
    role?.includes('gtns_admin') ||
    role?.includes('ptns_admin');

  const arrayPath = window.location.href.split('/');
  const formId = parseInt(arrayPath.slice(arrayPath.length - 1));

  if (!role || loading) return <CircularProgress style={{ marginTop: 128 }} />;

  return (
    <Grid item xs={12}>
      <Grid container spacing={2} style={{ marginTop: 16 }}>
        <Grid item xs={12} lg={3}>
          <Box style={{ position: 'sticky', top: 80 }}>
            <DanhSachThanhTichProfile formId={formId} />
          </Box>
        </Grid>
        <Grid item xs={12} lg={9}>
          <Card style={{ padding: 8, minHeight: 'calc(100vh - 124px)' }}>
            {/* achievementsOnly: chỉ hiện bảng thành tích KHCN + nút Xác nhận (admin) */}
            <HoSoDetail isSuperAdmin={isSuperAdmin} achievementsOnly />
          </Card>
        </Grid>
      </Grid>
    </Grid>
  );
}
